import { createReducer } from '@reduxjs/toolkit';
import {
  INotificationState,
  INotifications,
  INotificationsData,
  genericNotifType,
} from '../models/NotificationsModel';
import {
  getNotification,
  getNotificationLoad,
  getNotificationsCount,
  getNotificationsList,
  getNotificationsListPagination,
  logout,
  notificationReceived,
  setClickedNotification,
  setInitialNotification,
} from '../actions';
import {
  BookingState,
  NotificationPriorities,
  NotificationsType,
  RECEIVED_NOTIFICATIONS_LIMIT,
  responseType,
} from '../helpers/Constants';

export interface IClickedNotification {
  isRequested: boolean;
  item: null | INotificationsData;
}

export interface INotificationsInitialState {
  count: number;
  initialNotification: INotificationsData | null | genericNotifType;
  notificationsList: INotifications;
  notificationState: INotificationState;
  clickedNotification: IClickedNotification;
  // IDS THE BACKEND HAS ACKNOWLEDGED AS DELIVERED, KEEPS RECEIPTS FROM
  // BEING SENT TWICE FOR THE SAME PUSH
  receivedNotificationIds: Array<string>;
}

const initialState: INotificationsInitialState = {
  count: 0,
  notificationsList: {
    count: 0,
    totalCount: 0,
    data: [],
    pharmacistId: '',
    page: 1,
    itemPerPage: 1,
  },
  notificationState: {
    bookingState: BookingState.None,
    isAccessible: false,
    isViewed: false,
    status: '',
    userName: null,
    bookingId: '',
    notificationDate: '',
    notificationId: '',
    notificationType: NotificationsType.Unknown,
    text: '',
    workshiftId: '',
    isVisited: false,
    header: '',
    startDate: '',
    endDate: '',
    confirmBefore: null,
    priority:NotificationPriorities.normal,
  },
  initialNotification: null,
  clickedNotification: {
    isRequested: false,
    item: null,
  },
  receivedNotificationIds: [],
};

const notificationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getNotificationsList.fulfilled, (state, action) => {
      if (action.payload === responseType.noData) {
        state.notificationsList = {
          totalCount: 0,
          page: 1,
          data: [],
          count: 0,
          itemPerPage: 0,
          pharmacistId: '',
        };
      } else {
        state.notificationsList = action.payload;
      }
    })
    .addCase(getNotificationsListPagination.fulfilled, (state, action) => {
      if (action.payload === responseType.noData) return;
      state.notificationsList.count = action.payload.count;
      state.notificationsList.data.push(...action.payload.data);
    })
    .addCase(setInitialNotification, (state, action) => {
      state.initialNotification = action.payload;
    })
    .addCase(getNotification.fulfilled, (state, action) => {
      state.notificationState = action.payload;
    })
    .addCase(getNotificationLoad.fulfilled, (state, action) => {
      state.notificationState = action.payload;
    })
    .addCase(setClickedNotification, (state, action) => {
      state.clickedNotification = action.payload;
    })
    .addCase(notificationReceived.fulfilled, (state, action) => {
      // NULL MEANS THE RECEIPT NEVER REACHED THE BACKEND, SO IT STAYS RETRYABLE
      if (!action.payload) {
        return;
      }

      state.receivedNotificationIds = [
        ...state.receivedNotificationIds,
        action.payload,
      ].slice(-RECEIVED_NOTIFICATIONS_LIMIT);
    })
    .addCase(logout.fulfilled, () => {
      return initialState;
    })
    .addCase(getNotificationsCount.fulfilled, (state, action) => {
      state.count = action.payload.count;
    });
});

export default notificationReducer;
